<template>
  <div class="white-card p-3">
    <h5 class="text-green text-center">
      Je m'entraîne ✍
      <!--      <span class="fa fa-hand"></span>-->
    </h5>
    <div class="d-flex justify-content-center buttons-group my-4">
      <router-link tag="button" :to="{name: 'lesson-quiz',params: {slug: slug}}" v-if="has_quiz"
                   class="bg-white shadow text-green border-0 rounded-20 position-relative">
        <span class="fa fa-check position-absolute left-10 top-35"></span>
        Quizz
      </router-link>
      <router-link tag="button" :to="{name: 'lesson-exercises',params: {slug: slug}}"
                   v-if="has_exercises" class="bg-orange-100 shadow text-dark border-0 rounded-20 position-relative">
        <span class="svg-cup-train position-absolute"></span>
        Exercices
      </router-link>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    slug: {type: String, default: null},
    has_quiz: {type: Boolean, default: null},
    has_exercises: {type: Boolean, default: null}
  },
  data() {
    return {}
  },
  methods: {},
  computed: {},
  mounted() {
  }
}
</script>
<style lang="scss">
.buttons-group {
  button {
    text-align: center;
    padding: 15px !important;
    width: 40%;
    font-weight: 700;
  }

  button + button {
    margin-left: 20px;
  }
}
</style>
